import React from 'react'

import clsx from 'clsx'

import Card from 'components/Card'
import Skeleton from 'components/Skeleton'

import classes from './ArticleCardSkeleton.module.scss'

const ArticleCardSkeleton = () => {
  return (
    <Card className={clsx('ArticleCardSkeleton', classes.root)}>
      <Skeleton height={184} variant="rect" className={classes.image} />
      <div className={classes.border}>
        <Skeleton width={124} height={24} variant="rect" className={classes.title} />
        <Skeleton height={20} variant="rect" className={classes.content} />
        <Skeleton height={20} variant="rect" />
        <Skeleton width={91} height={20} variant="rect" className={classes.footer} />
      </div>
    </Card>
  )
}

export default ArticleCardSkeleton
